import styled from "styled-components";

export const Lista = styled.li`
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 40px;
  border: 1px solid #42918d;
  border-radius: 50px;
`;
